import styled from "styled-components";
import colours from "styles/colours";
import shadows from "styles/shadows";

export const Drawer = styled.div`
  margin: 10px 0 0 10px;
  width: 20vw;
  padding: 30px 10px 10px 32px;
  border-right: 3px solid ${colours.lightGrey};
  background-color: ${colours.lighterGrey};
  border-left: 2px solid ${colours.elexonBlue};
  min-width: 200px;
  box-shadow: ${shadows.shadowMd};
`;
